<template>
  <div class="page-content" style="padding-top: 5rem">
    <div class="container-fluid">
      <div class="card" id="orderList">
        <div>
          <div
            class="d-flex align-items-center py-4"
            style="text-align: left;background-color: #363740;"
          >
            <h6
              class=" flex-grow-1 text-center text-white fw-bold"
            >
              {{ admin.id ? "EDIT ADMIN" : "ADD ADMIN" }}
            </h6>
          </div>
        </div>

        <div class="card-body" style="text-align: left">
          <input type="hidden" id="admin.id" v-model="admin.id" value="" />
          <div class="row g-3">
            <div class="col-lg-12 mt-5">
              <div>
                <label for="name" class="form-label"
                  >Full Name<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="name"
                  v-model="admin.name"
                  @input="v$.admin.name.$touch()"
                  class="form-control"
                  placeholder="Enter Full Name"
                  required
                />
                <div class="error-message text-danger">
                  <span v-if="v$.admin.name.$errors.length">
                    {{ v$.admin.name.$errors[0].$message }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div>
                <label for="email" class="form-label"
                  >Email<span style="color: red">*</span></label
                >
                <input
                  type="email"
                  id="email"
                  @input="v$.admin.email.$touch()"
                  v-model="admin.email"
                  class="form-control"
                  placeholder="Enter Email"
                  required
                />
                <div class="error-message text-danger">
                  <span v-if="v$.admin.email.$errors.length">
                    {{ v$.admin.email.$errors[0].$message }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div>
                <label for="type" class="form-label">Role</label>
                <select
                  @blur="v$.admin.role.$touch()"
                  v-model="admin.role"
                  class="form-control"
                >
                  <option value="">Role</option>
                  <option value="admin">Admin</option>
                  <option value="superadmin">Super Admin</option>
                </select>
              </div>
              <div class="error-message text-danger">
                <span v-if="v$.admin.role.$errors.length">
                  {{ v$.admin.$attrsrole.$errors[0].$message }}
                </span>
              </div>
            </div>

            <div class="col-lg-12">
              <div>
                <label for="phone_number" class="form-label"
                  >Phone Number<span style="color: red">*</span></label
                >
                <input
                  @input="v$.admin.phone_number.$touch()"
                  type="text"
                  id="phone_number"
                  maxlength="10"
                  v-model="admin.phone_number"
                  class="form-control"
                  placeholder="Enter Mobile"
                  required
                />
                <div class="error-message text-danger">
                  <span v-if="v$.admin.phone_number.$errors.length">
                    {{ v$.admin.phone_number.$errors[0].$message }}
                  </span>
                </div>
              </div>
            </div>

            <div class="m-2 col-lg-12">
              <div
                :class="'alert alert-' + msgType + ' mb-xl-0'"
                role="alert"
                v-if="msgTxt && msgTxt.length > 0"
              >
                {{ msgTxt }}
              </div>
            </div>

            <div class="col-lg-12 mt-5">
              <div class="hstack gap-2 justify-content-end">
                <button
                  type="submit"
                  class="btn btn-warning"
                  style="width: 150px"
                  @click="handleSubmit"
                  :disabled="isDisabled"
                  :class="['button', { 'btn-disabled': isDisabled }]"
                >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <span v-else>{{
                    admin.id === null ? "Create" : "Update"
                  }}</span>
                </button>
                <button
                  style="width: 150px"
                  type="button"
                  @click="this.$router.back()"
                  class="btn text-warning border border-warning"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import { addAdmin, updateAdmin } from "@/apis/admin";
import {
  required,
  minLength,
  numeric,
  maxLength,
  email,
} from "@vuelidate/validators";
import entityFormMixin from "@/mixins/entityFormMixin";

export default {
  name: "AdminView",

  mixins: [entityFormMixin],

  data() {
    return {
      admin: {
        id: null,
        name: null,
        email: null,
        role: "",
        phone_number: null,
      },
    };
  },

  methods: {
    async handleSubmit() {
      const redirect = "/admins";
      const { id, ...data } = this.admin;

      if (id === null) {
        await this.save(null, data, addAdmin, redirect);
      } else {
        await this.save(id, data, updateAdmin, redirect);
      }
    },
  },

  mounted() {
    if (this.userEditData) {
      const { id, name, email, phone_number, role } = this.userEditData[0];

      this.admin = {
        id: id ?? null,
        name: name ?? "",
        email: email ?? "",
        role: role ?? "",
        phone_number: phone_number ?? "",
      };
    }
  },

  validations: {
    admin: {
      phone_number: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      email: {
        required,
        email,
      },
      role: {
        required,
      },
      name: {
        required,
      },
    },
  },

  computed: {
    isDisabled() {
      if (this.admin.id === null) {
        return this.v$.$invalid;
      } else {
        const anyDirty = Object.values(this.v$.admin).some(
          (field) => field.$dirty
        );
        return !anyDirty || this.v$.$invalid;
      }
    },
  },
};
</script>
